<template>
  <button
    type="button"
    class="drag-handle"
    :aria-label="label"
    :disabled="disabled"
  >
    <v-icon
      size="20"
      icon="mdi-drag"
    />
  </button>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  disabled: { type: Boolean, default: false },
});
</script>

<style scoped lang="less">
.drag-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: grab;
  color: @text-light;
  flex-shrink: 0;

  &:active {
    cursor: grabbing;
  }

  &:disabled {
    cursor: default;
    color: @text-light;
    opacity: 0.5;
  }
}
</style>
